// Mantine
// import { Skeleton, Grid, useMantineTheme } from "@mantine/core";
// Local - Components
// import { Services, Stats } from "./components";

const PageHome: React.FC = () => {
  // const theme = useMantineTheme();

  // const PRIMARY_COL_HEIGHT = 300;
  // const SECONDARY_COL_HEIGHT = PRIMARY_COL_HEIGHT / 2 - theme.spacing.md / 2;

  return (
    <>
      {/* <Grid columns={3}>
        <Grid.Col md={2} sm={3}>
          <Grid>
            <Grid.Col>
              <Stats />
            </Grid.Col>
          </Grid>
          <Grid columns={2}>
            <Grid.Col span={1}>
              <Skeleton
                height={PRIMARY_COL_HEIGHT}
                radius="md"
                animate={false}
              />
            </Grid.Col>
            <Grid.Col span={1}>
              <Skeleton
                height={PRIMARY_COL_HEIGHT}
                radius="md"
                animate={false}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col>
              <Skeleton
                height={PRIMARY_COL_HEIGHT}
                radius="md"
                animate={false}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
        <Grid.Col md={1} sm={3}>
          <Grid>
            <Grid.Col>
              <Services />
            </Grid.Col>
            <Grid.Col span={6}>
              <Skeleton
                height={SECONDARY_COL_HEIGHT}
                radius="md"
                animate={false}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <Skeleton
                height={SECONDARY_COL_HEIGHT}
                radius="md"
                animate={false}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid> */}
    </>
  );
};

export default PageHome;
